/**
 * Failures to load a lazy route's JavaScript chunk.
 *
 * A build gives every chunk a content hash, so the filename referenced by an old
 * document disappears the moment a new build is deployed. A tab that was opened
 * before the deploy therefore requests a chunk that no longer exists and the
 * dynamic `import()` rejects. Browsers word this differently, hence the list.
 */
const CHUNK_LOAD_MESSAGES = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Loading chunk',
  'Loading CSS chunk',
  'Unable to preload CSS',
];

/** True when `error` is a lazy chunk that could not be downloaded or parsed. */
export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  const message = error.message || '';
  return CHUNK_LOAD_MESSAGES.some((pattern) => message.includes(pattern));
}
